export default function HowToJoinEN() {
  return (
    <>
   <h2>How to Join: </h2>
    1. Easy Start: Log in with your registered passport to begin. <br/>
        If it's your first time, just click <b>"Register Now"</b> to get started quickly.<br/>
    2. Try Your Luck: Want to see how lucky you are? Click the <b>"Test Your Luck"</b> button and start the fun!<br/>
    3. Biggy’s Splash Challenge: Press the bright red button to send the ball flying. The goal is simple but exciting – you never know where the ball will land because it's all about luck!<br/>
    4. Winning: To win, just hit the target 2 times out of 3 tries. If you miss, don't worry, you still get something for trying!<br/>
    5. Prizes:<br/>
        Top Prize: Winners get a Lucky Voucher worth 300 THB, which you can use with no minimum spend.<br/>
        For Everyone Else: If you don't win, you still get an e-coupon just for playing.<br/>
    6. How to Use Your Voucher: Just show your registered passport at any Big C store across the country to get your prize. It’s easy!<br/>
   <br/> <br/>
    <h2>Guiding Stars - Terms & Conditions: </h2>
    1. One Journey Per Explorer: Each customer is granted a single chance to play.<br/>
    2. One Passport, One Opportunity: Ensure your passport is ready for this exclusive venture.<br/>
    3. Voucher Validity: Your e-coupon treasures remain valid for 30 days post-issue.<br/>
    4. Inbound Exclusive: This spectacular promotion is tailored for the intrepid international visitor to Thailand.<br/>
    5. Start from 1 Apr 2024 - 31 May 2024 only.<br/>
    6. Company's Compass: Additional guidelines set forth by the company apply.<br/>


    <br/> <br/>
    <h2>More Adventures: Stay Connected</h2>
    <br/>
    Facebook: <a href="https://www.facebook.com/BigCTouristsFavoritesTH" target="_blank" class="consent-link">https://www.facebook.com/BigCTouristsFavoritesTH</a><br/>
    Instagram: <a href="https://www.instagram.com/bigc.th/" target="_blank" class="consent-link">https://www.instagram.com/bigc.th/</a><br/>
    WeChat: <a href="https://mp.weixin.qq.com/s/LYI0Vt8y6-O3TTfmHkiVDw" target="_blank" class="consent-link">https://mp.weixin.qq.com/s/LYI0Vt8y6-O3TTfmHkiVDw</a><br/>
    <br/> 
    <h3>Dive into the Lucky Landing Campaign today and let fortune guide your way to unforgettable rewards!</h3>

    
    </>
  );
}
